var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", { attrs: { fluid: "" } }, [
    _c(
      "div",
      [
        _c(
          "v-tabs",
          {
            attrs: {
              color: "transparent",
              label: _vm.activeTab,
              "show-arrows": ""
            },
            model: {
              value: _vm.activeTab,
              callback: function($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab"
            }
          },
          [
            _c("v-tabs-slider", { attrs: { color: "primary" } }),
            _vm._v(" "),
            _vm._l(_vm.tabs, function(tabItem) {
              return _c("v-tab", { key: tabItem }, [
                _c("span", { staticClass: "tabItem" }, [
                  _vm._v("\n          " + _vm._s(tabItem) + "\n        ")
                ])
              ])
            }),
            _vm._v(" "),
            _c(
              "v-tab-item",
              { key: "active" },
              [
                _c("PaginationController", {
                  attrs: {
                    getDataActionName: "getImportService",
                    showDataLimit: _vm.showDataLimit,
                    searchBoxLabel: _vm.$t("search"),
                    searchBoxHint: _vm.$t("importSearchBoxHint"),
                    select: _vm.activeSelectedImportStatus || null,
                    isRefreshSelect: false,
                    haveSearchBox: "",
                    haveStartDate: ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "dataTable",
                      fn: function() {
                        return [
                          _c("v-data-table", {
                            staticClass: "elevation-2 myDense",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.activeBillingList,
                              "hide-actions": "",
                              "item-key": "_key",
                              "select-all": "blue",
                              pagination: _vm.activePagination,
                              value: _vm.selectedItems,
                              "rows-per-page-items": _vm.rowPerPage
                            },
                            on: {
                              "update:items": function($event) {
                                _vm.activeBillingList = $event
                              },
                              "update:pagination": function($event) {
                                _vm.activePagination = $event
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "headers",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "tr",
                                      [
                                        _c(
                                          "th",
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                "input-value": props.all,
                                                primary: "",
                                                "hide-details": ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.toggleAll.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(props.headers, function(header) {
                                          return _c(
                                            "th",
                                            {
                                              key: header.text,
                                              class: [
                                                "column sortable",
                                                _vm.activePagination.descending
                                                  ? "desc"
                                                  : "asc",
                                                header.value ===
                                                _vm.activePagination.sortBy
                                                  ? "active"
                                                  : ""
                                              ],
                                              style: {
                                                width: header.width,
                                                textAlign: header.align
                                              },
                                              on: {
                                                click: function($event) {
                                                  header.value ===
                                                    "createTime" &&
                                                    _vm.changeSort(
                                                      _vm.activePagination,
                                                      header.value
                                                    )
                                                }
                                              }
                                            },
                                            [
                                              header.value === "createTime"
                                                ? _c(
                                                    "v-icon",
                                                    { attrs: { small: "" } },
                                                    [_vm._v("arrow_upward")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(header.text) +
                                                  "\n                    "
                                              )
                                            ],
                                            1
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                }
                              },
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "checkbox-align-center" },
                                      [
                                        _c(
                                          "v-layout",
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                value: props.selected,
                                                primary: "",
                                                "hide-details": "",
                                                disabled:
                                                  props.item.billingNumber !==
                                                  props.item.masterBillingNumber
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.changeSelectedItems(
                                                    props
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(props.item.billingNumber) +
                                            "\n                    "
                                        ),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _vm.isAdmin &&
                                                      props.item
                                                        .billingNumber !==
                                                        props.item
                                                          .masterBillingNumber
                                                        ? _c(
                                                            "v-icon",
                                                            _vm._g(
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "10px",
                                                                  "line-height":
                                                                    "25px"
                                                                },
                                                                attrs: {
                                                                  color: "blue",
                                                                  small: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.copyToClipboard(
                                                                      props.item
                                                                        .masterBillingNumber
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                "content_copy"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "copyMasterBillingNumber"
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(props.item.containerNumber))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.toDateString(
                                            props.item.createTime
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { style: { whiteSpace: "pre-wrap" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            props.item.serviceTypes.length
                                              ? props.item.serviceTypes.reduce(
                                                  function(pre, cur) {
                                                    return (
                                                      _vm.$t(pre) +
                                                      "\n" +
                                                      _vm.$t(cur)
                                                    )
                                                  }
                                                )
                                              : ""
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.$t(props.item.lastStatus))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.isAdmin
                                      ? _c("td", [
                                          _vm._v(_vm._s(props.item.displayName))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isAdmin
                                      ? _c(
                                          "td",
                                          { style: { whiteSpace: "pre" } },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.internalNote)
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { attrs: { "text-xs-center": "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      dark: "",
                                                      color: "primary",
                                                      flat: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.showDetailPopup(
                                                          props.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                            " +
                                                        _vm._s(_vm.$t("open")) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.isAdmin
                                              ? _c(
                                                  "v-menu",
                                                  {
                                                    attrs: { "offset-y": "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            return [
                                                              _c(
                                                                "v-btn",
                                                                _vm._g(
                                                                  {
                                                                    attrs: {
                                                                      flat: "",
                                                                      dark: "",
                                                                      color:
                                                                        "primary"
                                                                    }
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "more"
                                                                        )
                                                                      )
                                                                  ),
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "expand_more"
                                                                    )
                                                                  ])
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list",
                                                      [
                                                        _c(
                                                          "v-list-tile",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.showCreatePopupAndProcess(
                                                                  props.item,
                                                                  "update"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-tile-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "edit"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        props.item
                                                          .billingNumber ===
                                                        props.item
                                                          .masterBillingNumber
                                                          ? _c(
                                                              "v-list-tile",
                                                              {
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.showCreatePopupAndProcess(
                                                                      props.item,
                                                                      "split"
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "split"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        props.item
                                                          .billingNumber ===
                                                        props.item
                                                          .masterBillingNumber
                                                          ? _c(
                                                              "v-list-tile",
                                                              {
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.updateItem(
                                                                      props.item,
                                                                      "close"
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "close"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.updateItem(
                                                                  props.item,
                                                                  "delete"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-tile-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "delete"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "beforeSearchBox",
                      fn: function() {
                        return [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "",
                                "justify-start": "",
                                "align-baseline": ""
                              }
                            },
                            [
                              _vm.isAdmin
                                ? _c(
                                    "v-flex",
                                    { staticStyle: { width: "205px" } },
                                    [
                                      _c(
                                        "v-layout",
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { sm6: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { color: "primary" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showCreatePopupAndProcess(
                                                        {},
                                                        "create"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { dark: "" } },
                                                    [_vm._v("add")]
                                                  ),
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "newImportBilling"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { sm6: "" } },
                                            [
                                              _vm.isAdmin
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "info",
                                                        disabled:
                                                          _vm.selectedItems
                                                            .length === 0
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.processMultiImportOrder(
                                                            "multiClose"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("lock")
                                                      ]),
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t("close")
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  style: _vm.isAdmin
                                    ? "width:200px"
                                    : "width:300px"
                                },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      label: _vm.$t("selectStatus"),
                                      items: _vm.statusList,
                                      "item-value": "status",
                                      "item-text": "text",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.activeSelectedImportStatus,
                                      callback: function($$v) {
                                        _vm.activeSelectedImportStatus = $$v
                                      },
                                      expression: "activeSelectedImportStatus"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ]),
                  model: {
                    value: _vm.activeBillingList,
                    callback: function($$v) {
                      _vm.activeBillingList = $$v
                    },
                    expression: "activeBillingList"
                  }
                }),
                _vm._v(" "),
                _c("SimpleTextPopup", {
                  attrs: { title: _vm.$t("importRelatedService"), medium: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c(
                              "v-container",
                              [
                                _c(
                                  "v-form",
                                  { ref: "popUpForm" },
                                  [
                                    _c(
                                      "v-container",
                                      [
                                        _c(
                                          "v-layout",
                                          { attrs: { column: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              [
                                                _c(
                                                  "v-layout",
                                                  {
                                                    attrs: {
                                                      "justify-space-between":
                                                        ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm5: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly:
                                                              _vm.actionType !==
                                                              "create",
                                                            label: _vm.$t(
                                                              "billingNumber"
                                                            ),
                                                            rules: [
                                                              _vm.fieldIsRequired(
                                                                _vm.$t(
                                                                  "billingNumber"
                                                                )
                                                              )
                                                            ]
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .tableDataIndeed
                                                                .billingNumber,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.tableDataIndeed,
                                                                "billingNumber",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "tableDataIndeed.billingNumber"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm5: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            readonly:
                                                              _vm.actionType ===
                                                                "split" ||
                                                              _vm
                                                                .detailInShowItem
                                                                .billingNumber !==
                                                                _vm
                                                                  .detailInShowItem
                                                                  .masterBillingNumber ||
                                                              !!(
                                                                _vm
                                                                  .detailInShowItem
                                                                  .associatedBillingList &&
                                                                _vm
                                                                  .detailInShowItem
                                                                  .associatedBillingList
                                                                  .length
                                                              ),
                                                            label: _vm.$t(
                                                              "containerNumber"
                                                            )
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .tableDataIndeed
                                                                .containerNumber,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.tableDataIndeed,
                                                                "containerNumber",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "tableDataIndeed.containerNumber"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              [
                                                _c(
                                                  "v-layout",
                                                  {
                                                    attrs: {
                                                      "justify-space-between":
                                                        "",
                                                      "align-end": ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm5: "" } },
                                                      [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "client"
                                                            ),
                                                            items:
                                                              _vm.overseaCustomersList,
                                                            readonly:
                                                              _vm.actionType ===
                                                                "update" &&
                                                              _vm
                                                                .detailInShowItem
                                                                .lastStatus !==
                                                                "created",
                                                            "item-value":
                                                              "userKey",
                                                            "item-text":
                                                              "displayName",
                                                            clearable:
                                                              _vm
                                                                .detailInShowItem
                                                                .lastStatus ===
                                                              "created"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .tableDataIndeed
                                                                .userKey,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.tableDataIndeed,
                                                                "userKey",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "tableDataIndeed.userKey"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm5: "" } },
                                                      [
                                                        _c("v-combobox", {
                                                          attrs: {
                                                            items:
                                                              _vm.serviceTypeList,
                                                            "item-text":
                                                              "displayName",
                                                            "item-value":
                                                              "displayName",
                                                            label: _vm.$t(
                                                              "serviceType"
                                                            ),
                                                            "return-object": false,
                                                            required: "",
                                                            chips: "",
                                                            multiple: "",
                                                            clearable: ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.selectedServiceTypes,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.selectedServiceTypes = $$v
                                                            },
                                                            expression:
                                                              "selectedServiceTypes"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              [
                                                _c("v-textarea", {
                                                  attrs: {
                                                    outline: "",
                                                    name: "input-7-4",
                                                    label: _vm.$t(
                                                      "internalNote"
                                                    )
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.tableDataIndeed
                                                        .internalNote,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.tableDataIndeed,
                                                        "internalNote",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "tableDataIndeed.internalNote"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "popupAction",
                        fn: function() {
                          return [
                            _c(
                              "v-layout",
                              {
                                attrs: { row: "", "justify-space-between": "" }
                              },
                              [
                                _c(
                                  "v-flex",
                                  { staticClass: "text-xs-left" },
                                  [
                                    _vm._t("left_button", function() {
                                      return [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              flat: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.cancelAndCloseDialog.apply(
                                                  null,
                                                  arguments
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("close")))]
                                        )
                                      ]
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { staticClass: "text-xs-right" },
                                  [
                                    _vm._t("right_button", function() {
                                      return [
                                        _c("LoaderButton", {
                                          attrs: {
                                            flat: "",
                                            isSmall: "",
                                            promiseAwait:
                                              _vm.closeDialogAndProcessImport,
                                            buttonText: _vm.$t("save")
                                          }
                                        })
                                      ]
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.isShowCreatePopup,
                    callback: function($$v) {
                      _vm.isShowCreatePopup = $$v
                    },
                    expression: "isShowCreatePopup"
                  }
                }),
                _vm._v(" "),
                _c("SimpleTextPopup", {
                  attrs: {
                    large: true,
                    leftMethod: _vm.closeDetailDialog,
                    hideRgtBtn: true,
                    title: _vm.$t("importRelateInfo", {
                      billingNumber: _vm.detailInShowItem.billingNumber,
                      containerNumber: _vm.detailInShowItem.containerNumber
                    })
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "input",
                      fn: function() {
                        return [
                          _c(
                            "v-container",
                            { attrs: { fluid: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs3: "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            "justify-start": "",
                                            column: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-toolbar",
                                            {
                                              attrs: {
                                                color: "primary",
                                                dark: ""
                                              }
                                            },
                                            [
                                              _c("v-toolbar-title", [
                                                _vm._v(_vm._s(_vm.$t("status")))
                                              ]),
                                              _vm._v(" "),
                                              _c("v-spacer")
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.cards, function(
                                            card,
                                            index
                                          ) {
                                            return _c(
                                              "v-flex",
                                              {
                                                key:
                                                  String(card.operationTime) +
                                                  "_" +
                                                  index,
                                                attrs: { xs12: "", sm8: "" }
                                              },
                                              [
                                                _c(
                                                  "v-card",
                                                  [
                                                    _c(
                                                      "v-layout",
                                                      {
                                                        attrs: {
                                                          column: "",
                                                          wrap: ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              "mt-2": "",
                                                              "mb-2": ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-card",
                                                              {
                                                                staticStyle: {
                                                                  "max-width":
                                                                    "300px",
                                                                  height:
                                                                    "60px",
                                                                  margin:
                                                                    "auto",
                                                                  color: "white"
                                                                },
                                                                attrs: {
                                                                  color: "info"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-container",
                                                                  {
                                                                    staticStyle: {
                                                                      padding:
                                                                        "10px",
                                                                      color:
                                                                        "white",
                                                                      "font-weight":
                                                                        "700"
                                                                    },
                                                                    attrs: {
                                                                      fluid: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-layout",
                                                                      {
                                                                        attrs: {
                                                                          "align-center":
                                                                            "",
                                                                          "justify-center":
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-flex",
                                                                          {
                                                                            attrs: {
                                                                              sm1:
                                                                                "",
                                                                              "mr-4":
                                                                                ""
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle: {
                                                                                  border:
                                                                                    "1px",
                                                                                  background:
                                                                                    "white",
                                                                                  "border-radius":
                                                                                    "50%",
                                                                                  color:
                                                                                    "#2196f3",
                                                                                  "text-align":
                                                                                    "center"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                              " +
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .cards
                                                                                        .length -
                                                                                        index
                                                                                    ) +
                                                                                    "\n                                            "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-flex",
                                                                          {
                                                                            attrs: {
                                                                              sm9:
                                                                                ""
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-layout",
                                                                              {
                                                                                attrs: {
                                                                                  column:
                                                                                    "",
                                                                                  "justify-start":
                                                                                    "",
                                                                                  "align-start":
                                                                                    ""
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-flex",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.toTimestampString(
                                                                                          card.operationTime
                                                                                        )
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "v-flex",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          card.status
                                                                                        )
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                false
                                                                                  ? _c(
                                                                                      "v-flex",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "操作人: " +
                                                                                            _vm._s(
                                                                                              card.operator
                                                                                            )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e()
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          })
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs9: "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { "justify-center": "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs11: "" } },
                                            [
                                              _c(
                                                "v-toolbar",
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    dark: ""
                                                  }
                                                },
                                                [
                                                  _c("v-toolbar-title", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "filesAndOperation"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-spacer")
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-container",
                                                    {
                                                      attrs: {
                                                        fluid: "",
                                                        "grid-list-md": ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            column: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _vm.isAdmin
                                                            ? _c(
                                                                "v-flex",
                                                                [
                                                                  _vm.activeTab ===
                                                                  0
                                                                    ? _c(
                                                                        "v-layout",
                                                                        [
                                                                          _c(
                                                                            "v-flex",
                                                                            {
                                                                              attrs: {
                                                                                sm6:
                                                                                  "",
                                                                                "ml-4":
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-autocomplete",
                                                                                {
                                                                                  attrs: {
                                                                                    label: _vm.$t(
                                                                                      "status"
                                                                                    ),
                                                                                    items:
                                                                                      _vm.statusList,
                                                                                    "item-value":
                                                                                      "status",
                                                                                    "item-text":
                                                                                      "text",
                                                                                    "no-data-text":
                                                                                      "all",
                                                                                    clearable:
                                                                                      ""
                                                                                  },
                                                                                  model: {
                                                                                    value:
                                                                                      _vm.newStatus,
                                                                                    callback: function(
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.newStatus = $$v
                                                                                    },
                                                                                    expression:
                                                                                      "newStatus"
                                                                                  }
                                                                                }
                                                                              )
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "v-flex",
                                                                            {
                                                                              attrs: {
                                                                                "ml-4":
                                                                                  "",
                                                                                sm2:
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "LoaderButton",
                                                                                {
                                                                                  attrs: {
                                                                                    promiseAwait:
                                                                                      _vm.updateOrderStatus,
                                                                                    promiseItem: {
                                                                                      type:
                                                                                        "admin"
                                                                                    },
                                                                                    buttonText: _vm.$t(
                                                                                      "changeStatus"
                                                                                    )
                                                                                  }
                                                                                }
                                                                              )
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _vm
                                                                            .detailInShowItem
                                                                            .billingNumber ===
                                                                            _vm
                                                                              .detailInShowItem
                                                                              .masterBillingNumber &&
                                                                          _vm
                                                                            .detailInShowItem
                                                                            .associatedBillingList &&
                                                                          _vm
                                                                            .detailInShowItem
                                                                            .associatedBillingList
                                                                            .length
                                                                            ? _c(
                                                                                "v-flex",
                                                                                {
                                                                                  attrs: {
                                                                                    sm2:
                                                                                      ""
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-checkbox",
                                                                                    {
                                                                                      attrs: {
                                                                                        label: _vm.$t(
                                                                                          "syncAssociations"
                                                                                        )
                                                                                      },
                                                                                      model: {
                                                                                        value:
                                                                                          _vm.isSyncAssociatedImports,
                                                                                        callback: function(
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.isSyncAssociatedImports = $$v
                                                                                        },
                                                                                        expression:
                                                                                          "isSyncAssociatedImports"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e()
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          !_vm.isAdmin &&
                                                          _vm.detailInShowItem
                                                            .lastStatus ===
                                                            "customFileReadyToConfirm" &&
                                                          _vm.isMatchClient
                                                            ? _c(
                                                                "v-flex",
                                                                [
                                                                  !_vm
                                                                    .detailInShowItem
                                                                    .close
                                                                    ? _c(
                                                                        "v-card",
                                                                        [
                                                                          _c(
                                                                            "v-container",
                                                                            {
                                                                              attrs: {
                                                                                fluid:
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-layout",
                                                                                {
                                                                                  attrs: {
                                                                                    "justify-center":
                                                                                      "",
                                                                                    "align-center":
                                                                                      ""
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-flex",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "areYouSureToConfirmClearance"
                                                                                          )
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "v-flex",
                                                                                    {
                                                                                      attrs: {
                                                                                        xs3:
                                                                                          ""
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "LoaderButton",
                                                                                        {
                                                                                          attrs: {
                                                                                            promiseAwait:
                                                                                              _vm.updateOrderStatus,
                                                                                            promiseItem: {
                                                                                              type:
                                                                                                "user"
                                                                                            },
                                                                                            buttonText: _vm.$t(
                                                                                              "confirmToCustomsClearance"
                                                                                            )
                                                                                          }
                                                                                        }
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          !_vm.isAdmin &&
                                                          _vm.detailInShowItem
                                                            .lastStatus ===
                                                            "customFileConfirmed"
                                                            ? _c(
                                                                "v-flex",
                                                                [
                                                                  _c(
                                                                    "v-card",
                                                                    [
                                                                      _c(
                                                                        "v-container",
                                                                        [
                                                                          _c(
                                                                            "v-layout",
                                                                            {
                                                                              attrs: {
                                                                                "justify-center":
                                                                                  "",
                                                                                "align-center":
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-flex",
                                                                                {
                                                                                  attrs: {
                                                                                    xs8:
                                                                                      ""
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        "thanksForSupport"
                                                                                      )
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                "mt-4": ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-layout",
                                                                {
                                                                  attrs: {
                                                                    column: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      staticStyle: {
                                                                        "font-size":
                                                                          "18px"
                                                                      },
                                                                      attrs: {
                                                                        sm2: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "filesList"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._l(
                                                                    _vm.filesTitleOrderList,
                                                                    function(
                                                                      ref
                                                                    ) {
                                                                      var value =
                                                                        ref.value
                                                                      var type =
                                                                        ref.type
                                                                      return _c(
                                                                        "v-flex",
                                                                        {
                                                                          key: type
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-layout",
                                                                            {
                                                                              attrs: {
                                                                                column:
                                                                                  "",
                                                                                "justify-start":
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-flex",
                                                                                {
                                                                                  attrs: {
                                                                                    "ml-4":
                                                                                      "",
                                                                                    sm6:
                                                                                      ""
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.setUploadFileType(
                                                                                        type
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "strong",
                                                                                    {
                                                                                      staticStyle: {
                                                                                        "font-weight":
                                                                                          "700",
                                                                                        display:
                                                                                          "inline-block",
                                                                                        width:
                                                                                          "100px"
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          value
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "UploadFileWidget",
                                                                                    {
                                                                                      ref:
                                                                                        "fileUploader",
                                                                                      refInFor: true,
                                                                                      attrs: {
                                                                                        clearFiles: true,
                                                                                        disabled:
                                                                                          (type ===
                                                                                            "deliveryFiles" &&
                                                                                            _vm
                                                                                              .filesListOfInshowItem[
                                                                                              type
                                                                                            ] &&
                                                                                            _vm
                                                                                              .filesListOfInshowItem[
                                                                                              type
                                                                                            ]
                                                                                              .length >=
                                                                                              1) ||
                                                                                          (!_vm.isAdmin &&
                                                                                            type ===
                                                                                              "billingFiles") ||
                                                                                          (_vm
                                                                                            .filesListOfInshowItem[
                                                                                            type
                                                                                          ] &&
                                                                                            _vm
                                                                                              .filesListOfInshowItem[
                                                                                              type
                                                                                            ]
                                                                                              .length >=
                                                                                              5) ||
                                                                                          _vm.isUploading ||
                                                                                          !_vm.isMatchClient ||
                                                                                          (_vm.activeTab ===
                                                                                            1 &&
                                                                                            !_vm.isAdmin),
                                                                                        type:
                                                                                          "import" +
                                                                                          "/" +
                                                                                          _vm
                                                                                            .detailInShowItem
                                                                                            .billingNumber,
                                                                                        iconType:
                                                                                          "add",
                                                                                        isCheckDuplicates:
                                                                                          "",
                                                                                        loading:
                                                                                          _vm.isUploading &&
                                                                                          type ===
                                                                                            _vm.uploadingFileType,
                                                                                        icon:
                                                                                          ""
                                                                                      },
                                                                                      on: {
                                                                                        getUploadingFileData:
                                                                                          _vm.getUploadingFileDataAndSaveFileInfo
                                                                                      },
                                                                                      model: {
                                                                                        value:
                                                                                          _vm.newFiles,
                                                                                        callback: function(
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.newFiles = $$v
                                                                                        },
                                                                                        expression:
                                                                                          "newFiles"
                                                                                      }
                                                                                    }
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  type ===
                                                                                  "deliveryFiles"
                                                                                    ? _c(
                                                                                        "v-tooltip",
                                                                                        {
                                                                                          attrs: {
                                                                                            top:
                                                                                              ""
                                                                                          },
                                                                                          scopedSlots: _vm._u(
                                                                                            [
                                                                                              {
                                                                                                key:
                                                                                                  "activator",
                                                                                                fn: function(
                                                                                                  tooltip
                                                                                                ) {
                                                                                                  return [
                                                                                                    _c(
                                                                                                      "div",
                                                                                                      _vm._g(
                                                                                                        {
                                                                                                          staticStyle: {
                                                                                                            display:
                                                                                                              "inline-block"
                                                                                                          }
                                                                                                        },
                                                                                                        tooltip.on
                                                                                                      ),
                                                                                                      [
                                                                                                        type ===
                                                                                                        "deliveryFiles"
                                                                                                          ? _c(
                                                                                                              "v-btn",
                                                                                                              {
                                                                                                                attrs: {
                                                                                                                  plain:
                                                                                                                    "",
                                                                                                                  flat:
                                                                                                                    "",
                                                                                                                  color:
                                                                                                                    "primary"
                                                                                                                },
                                                                                                                on: {
                                                                                                                  click:
                                                                                                                    _vm.downloadTemplate
                                                                                                                }
                                                                                                              },
                                                                                                              [
                                                                                                                _c(
                                                                                                                  "v-icon",
                                                                                                                  [
                                                                                                                    _vm._v(
                                                                                                                      "download"
                                                                                                                    )
                                                                                                                  ]
                                                                                                                ),
                                                                                                                _vm._v(
                                                                                                                  _vm._s(
                                                                                                                    _vm.$t(
                                                                                                                      "template"
                                                                                                                    )
                                                                                                                  )
                                                                                                                )
                                                                                                              ],
                                                                                                              1
                                                                                                            )
                                                                                                          : _vm._e()
                                                                                                      ],
                                                                                                      1
                                                                                                    )
                                                                                                  ]
                                                                                                }
                                                                                              }
                                                                                            ],
                                                                                            null,
                                                                                            true
                                                                                          )
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                        " +
                                                                                              _vm._s(
                                                                                                _vm.$t(
                                                                                                  "template"
                                                                                                )
                                                                                              ) +
                                                                                              "\n                                      "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e()
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "v-flex",
                                                                                {
                                                                                  attrs: {
                                                                                    "ml-5":
                                                                                      "",
                                                                                    xs10:
                                                                                      ""
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-list",
                                                                                    {
                                                                                      staticStyle: {
                                                                                        padding:
                                                                                          "0px"
                                                                                      }
                                                                                    },
                                                                                    _vm._l(
                                                                                      _vm
                                                                                        .mergedFilesList[
                                                                                        type
                                                                                      ],
                                                                                      function(
                                                                                        subItem
                                                                                      ) {
                                                                                        return _c(
                                                                                          "v-list-tile",
                                                                                          {
                                                                                            key:
                                                                                              subItem.downloadURL,
                                                                                            staticStyle: {
                                                                                              height:
                                                                                                "25px",
                                                                                              padding:
                                                                                                "0px"
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "v-layout",
                                                                                              {
                                                                                                staticStyle: {
                                                                                                  margin:
                                                                                                    "0px",
                                                                                                  padding:
                                                                                                    "0px",
                                                                                                  height:
                                                                                                    "50px"
                                                                                                },
                                                                                                attrs: {
                                                                                                  "align-start":
                                                                                                    ""
                                                                                                }
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "v-flex",
                                                                                                  {
                                                                                                    staticStyle: {
                                                                                                      "font-size":
                                                                                                        "14px"
                                                                                                    },
                                                                                                    attrs: {
                                                                                                      sm6:
                                                                                                        ""
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "\n                                               " +
                                                                                                        _vm._s(
                                                                                                          subItem.name
                                                                                                        ) +
                                                                                                        "\n                                             "
                                                                                                    )
                                                                                                  ]
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " "
                                                                                                ),
                                                                                                _c(
                                                                                                  "v-flex",
                                                                                                  {
                                                                                                    staticStyle: {
                                                                                                      "font-size":
                                                                                                        "14px"
                                                                                                    },
                                                                                                    attrs: {
                                                                                                      sm3:
                                                                                                        ""
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "\n                                               " +
                                                                                                        _vm._s(
                                                                                                          _vm.toTimestampString(
                                                                                                            subItem.uploadTime
                                                                                                          )
                                                                                                        ) +
                                                                                                        "\n                                             "
                                                                                                    )
                                                                                                  ]
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " "
                                                                                                ),
                                                                                                _vm.isAdmin &&
                                                                                                _vm
                                                                                                  .detailInShowItem
                                                                                                  .billingNumber ===
                                                                                                  _vm
                                                                                                    .detailInShowItem
                                                                                                    .masterBillingNumber
                                                                                                  ? _c(
                                                                                                      "v-flex",
                                                                                                      {
                                                                                                        staticStyle: {
                                                                                                          "font-size":
                                                                                                            "14px"
                                                                                                        },
                                                                                                        attrs: {
                                                                                                          sm3:
                                                                                                            ""
                                                                                                        },
                                                                                                        on: {
                                                                                                          click: function(
                                                                                                            $event
                                                                                                          ) {
                                                                                                            $event.preventDefault()
                                                                                                            return _vm.changeFileIsSharedStatus(
                                                                                                              subItem,
                                                                                                              type
                                                                                                            )
                                                                                                          }
                                                                                                        }
                                                                                                      },
                                                                                                      [
                                                                                                        subItem.hasOwnProperty(
                                                                                                          "isShared"
                                                                                                        ) &&
                                                                                                        !subItem.isLoadingShareBtn
                                                                                                          ? _c(
                                                                                                              "v-checkbox",
                                                                                                              {
                                                                                                                staticStyle: {
                                                                                                                  "font-size":
                                                                                                                    "14px",
                                                                                                                  display:
                                                                                                                    "inline-block"
                                                                                                                },
                                                                                                                attrs: {
                                                                                                                  label: _vm.$t(
                                                                                                                    "public"
                                                                                                                  ),
                                                                                                                  disabled:
                                                                                                                    subItem.isLoadingShareBtn
                                                                                                                },
                                                                                                                model: {
                                                                                                                  value:
                                                                                                                    subItem.isShared,
                                                                                                                  callback: function(
                                                                                                                    $$v
                                                                                                                  ) {
                                                                                                                    _vm.$set(
                                                                                                                      subItem,
                                                                                                                      "isShared",
                                                                                                                      $$v
                                                                                                                    )
                                                                                                                  },
                                                                                                                  expression:
                                                                                                                    "subItem.isShared"
                                                                                                                }
                                                                                                              }
                                                                                                            )
                                                                                                          : _vm._e(),
                                                                                                        _vm._v(
                                                                                                          " "
                                                                                                        ),
                                                                                                        subItem.isLoadingShareBtn
                                                                                                          ? _c(
                                                                                                              "v-btn",
                                                                                                              {
                                                                                                                attrs: {
                                                                                                                  flat:
                                                                                                                    "",
                                                                                                                  small:
                                                                                                                    "",
                                                                                                                  loading:
                                                                                                                    ""
                                                                                                                }
                                                                                                              }
                                                                                                            )
                                                                                                          : _vm._e()
                                                                                                      ],
                                                                                                      1
                                                                                                    )
                                                                                                  : _vm._e(),
                                                                                                _vm._v(
                                                                                                  " "
                                                                                                ),
                                                                                                _c(
                                                                                                  "v-flex",
                                                                                                  {
                                                                                                    attrs: {
                                                                                                      sm3:
                                                                                                        ""
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "v-layout",
                                                                                                      {
                                                                                                        attrs: {
                                                                                                          row:
                                                                                                            ""
                                                                                                        }
                                                                                                      },
                                                                                                      [
                                                                                                        _c(
                                                                                                          "v-flex",
                                                                                                          {
                                                                                                            attrs: {
                                                                                                              sm2:
                                                                                                                ""
                                                                                                            }
                                                                                                          },
                                                                                                          [
                                                                                                            _c(
                                                                                                              "v-tooltip",
                                                                                                              {
                                                                                                                attrs: {
                                                                                                                  top:
                                                                                                                    ""
                                                                                                                },
                                                                                                                scopedSlots: _vm._u(
                                                                                                                  [
                                                                                                                    {
                                                                                                                      key:
                                                                                                                        "activator",
                                                                                                                      fn: function(
                                                                                                                        tooltip
                                                                                                                      ) {
                                                                                                                        return [
                                                                                                                          _c(
                                                                                                                            "div",
                                                                                                                            _vm._g(
                                                                                                                              {},
                                                                                                                              tooltip.on
                                                                                                                            ),
                                                                                                                            [
                                                                                                                              _vm.isAdmin ||
                                                                                                                              (type !==
                                                                                                                                "billingFiles" &&
                                                                                                                                subItem.uploader ===
                                                                                                                                  _vm
                                                                                                                                    .user
                                                                                                                                    .uid &&
                                                                                                                                _vm.isMatchClient)
                                                                                                                                ? _c(
                                                                                                                                    "v-icon",
                                                                                                                                    {
                                                                                                                                      on: {
                                                                                                                                        click: function(
                                                                                                                                          $event
                                                                                                                                        ) {
                                                                                                                                          return _vm.deleteFileFromStorage(
                                                                                                                                            subItem,
                                                                                                                                            type
                                                                                                                                          )
                                                                                                                                        }
                                                                                                                                      }
                                                                                                                                    },
                                                                                                                                    [
                                                                                                                                      _vm._v(
                                                                                                                                        "delete"
                                                                                                                                      )
                                                                                                                                    ]
                                                                                                                                  )
                                                                                                                                : _vm._e()
                                                                                                                            ],
                                                                                                                            1
                                                                                                                          )
                                                                                                                        ]
                                                                                                                      }
                                                                                                                    }
                                                                                                                  ],
                                                                                                                  null,
                                                                                                                  true
                                                                                                                )
                                                                                                              },
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  "\n                                                    " +
                                                                                                                    _vm._s(
                                                                                                                      _vm.$t(
                                                                                                                        "delete"
                                                                                                                      )
                                                                                                                    ) +
                                                                                                                    "\n                                                  "
                                                                                                                )
                                                                                                              ]
                                                                                                            )
                                                                                                          ],
                                                                                                          1
                                                                                                        ),
                                                                                                        _vm._v(
                                                                                                          " "
                                                                                                        ),
                                                                                                        _c(
                                                                                                          "v-flex",
                                                                                                          {
                                                                                                            attrs: {
                                                                                                              sm2:
                                                                                                                ""
                                                                                                            }
                                                                                                          },
                                                                                                          [
                                                                                                            _c(
                                                                                                              "v-tooltip",
                                                                                                              {
                                                                                                                attrs: {
                                                                                                                  top:
                                                                                                                    ""
                                                                                                                },
                                                                                                                scopedSlots: _vm._u(
                                                                                                                  [
                                                                                                                    {
                                                                                                                      key:
                                                                                                                        "activator",
                                                                                                                      fn: function(
                                                                                                                        tooltip
                                                                                                                      ) {
                                                                                                                        return [
                                                                                                                          _c(
                                                                                                                            "div",
                                                                                                                            _vm._g(
                                                                                                                              {},
                                                                                                                              tooltip.on
                                                                                                                            ),
                                                                                                                            [
                                                                                                                              _c(
                                                                                                                                "a",
                                                                                                                                {
                                                                                                                                  attrs: {
                                                                                                                                    href:
                                                                                                                                      subItem.downloadURL,
                                                                                                                                    download:
                                                                                                                                      "",
                                                                                                                                    target:
                                                                                                                                      "_blank"
                                                                                                                                  }
                                                                                                                                },
                                                                                                                                [
                                                                                                                                  _vm.isAdmin ||
                                                                                                                                  (!_vm.isAdmin &&
                                                                                                                                    _vm.isMatchClient)
                                                                                                                                    ? _c(
                                                                                                                                        "v-icon",
                                                                                                                                        [
                                                                                                                                          _vm._v(
                                                                                                                                            "cloud_download"
                                                                                                                                          )
                                                                                                                                        ]
                                                                                                                                      )
                                                                                                                                    : _vm._e()
                                                                                                                                ],
                                                                                                                                1
                                                                                                                              )
                                                                                                                            ]
                                                                                                                          )
                                                                                                                        ]
                                                                                                                      }
                                                                                                                    }
                                                                                                                  ],
                                                                                                                  null,
                                                                                                                  true
                                                                                                                )
                                                                                                              },
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  "\n                                                    " +
                                                                                                                    _vm._s(
                                                                                                                      _vm.$t(
                                                                                                                        "download"
                                                                                                                      )
                                                                                                                    ) +
                                                                                                                    "\n                                                  "
                                                                                                                )
                                                                                                              ]
                                                                                                            )
                                                                                                          ],
                                                                                                          1
                                                                                                        )
                                                                                                      ],
                                                                                                      1
                                                                                                    )
                                                                                                  ],
                                                                                                  1
                                                                                                )
                                                                                              ],
                                                                                              1
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      }
                                                                                    ),
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.detailInShowItem
                                                            .deliveryInfo &&
                                                          _vm.detailInShowItem
                                                            .deliveryInfo
                                                            .length !== 0
                                                            ? _c(
                                                                "v-flex",
                                                                [
                                                                  _c(
                                                                    "v-layout",
                                                                    {
                                                                      attrs: {
                                                                        column:
                                                                          "",
                                                                        "mt-4":
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-flex",
                                                                        {
                                                                          attrs: {
                                                                            sm2:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-layout",
                                                                            [
                                                                              _c(
                                                                                "v-flex",
                                                                                {
                                                                                  staticStyle: {
                                                                                    "font-size":
                                                                                      "18px"
                                                                                  },
                                                                                  attrs: {
                                                                                    "mb-2":
                                                                                      ""
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "strong",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "deliveryStatus"
                                                                                          )
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "v-flex",
                                                                        {
                                                                          attrs: {
                                                                            "ml-4":
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-data-table",
                                                                            {
                                                                              staticClass:
                                                                                "elevation-1",
                                                                              attrs: {
                                                                                headers:
                                                                                  _vm.deliveryHeaders,
                                                                                "rows-per-page-items": [
                                                                                  10,
                                                                                  20,
                                                                                  30
                                                                                ],
                                                                                items:
                                                                                  _vm
                                                                                    .detailInShowItem
                                                                                    .deliveryInfo
                                                                              },
                                                                              scopedSlots: _vm._u(
                                                                                [
                                                                                  {
                                                                                    key:
                                                                                      "items",
                                                                                    fn: function(
                                                                                      props
                                                                                    ) {
                                                                                      return [
                                                                                        _c(
                                                                                          "td",
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                props
                                                                                                  .item
                                                                                                  .channel
                                                                                              )
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "td",
                                                                                          {
                                                                                            staticClass:
                                                                                              "text-xs-left"
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                props
                                                                                                  .item
                                                                                                  .quantity
                                                                                              )
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "td",
                                                                                          {
                                                                                            staticClass:
                                                                                              "text-xs-left"
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                props
                                                                                                  .item
                                                                                                  .flag
                                                                                              )
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "td",
                                                                                          {
                                                                                            staticClass:
                                                                                              "text-xs-left"
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                props
                                                                                                  .item
                                                                                                  .weight
                                                                                              )
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "td",
                                                                                          {
                                                                                            staticClass:
                                                                                              "text-xs-left"
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                props
                                                                                                  .item
                                                                                                  .volume
                                                                                              )
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "td",
                                                                                          {
                                                                                            staticClass:
                                                                                              "text-xs-left"
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                props
                                                                                                  .item
                                                                                                  .note
                                                                                              )
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _vm.isAdmin
                                                                                          ? _c(
                                                                                              "td",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "justify-center layout px-0"
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "v-autocomplete",
                                                                                                  {
                                                                                                    attrs: {
                                                                                                      items:
                                                                                                        _vm.deliveryStatusList,
                                                                                                      "item-value":
                                                                                                        "status",
                                                                                                      "item-text":
                                                                                                        "text"
                                                                                                    },
                                                                                                    model: {
                                                                                                      value:
                                                                                                        props
                                                                                                          .item
                                                                                                          .deliveryStatus,
                                                                                                      callback: function(
                                                                                                        $$v
                                                                                                      ) {
                                                                                                        _vm.$set(
                                                                                                          props.item,
                                                                                                          "deliveryStatus",
                                                                                                          $$v
                                                                                                        )
                                                                                                      },
                                                                                                      expression:
                                                                                                        "props.item.deliveryStatus"
                                                                                                    }
                                                                                                  }
                                                                                                )
                                                                                              ],
                                                                                              1
                                                                                            )
                                                                                          : _c(
                                                                                              "td",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "\n                                        " +
                                                                                                    _vm._s(
                                                                                                      _vm.$t(
                                                                                                        props
                                                                                                          .item
                                                                                                          .deliveryStatus
                                                                                                      )
                                                                                                    ) +
                                                                                                    "\n                                      "
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                      ]
                                                                                    }
                                                                                  }
                                                                                ],
                                                                                null,
                                                                                false,
                                                                                4078232136
                                                                              )
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-flex",
                                                            [
                                                              _vm.isAdmin
                                                                ? _c(
                                                                    "v-layout",
                                                                    {
                                                                      attrs: {
                                                                        "mt-4":
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-flex",
                                                                        {
                                                                          attrs: {
                                                                            sm2:
                                                                              "",
                                                                            "ml-4":
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-text-field",
                                                                            {
                                                                              attrs: {
                                                                                label:
                                                                                  "HSCode"
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  _vm.HSCode,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.HSCode = $$v
                                                                                },
                                                                                expression:
                                                                                  "HSCode"
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm.isAdmin
                                                                        ? _c(
                                                                            "v-flex",
                                                                            {
                                                                              attrs: {
                                                                                sm9:
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-layout",
                                                                                {
                                                                                  attrs: {
                                                                                    "justify-end":
                                                                                      ""
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-flex",
                                                                                    {
                                                                                      attrs: {
                                                                                        sm2:
                                                                                          ""
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "LoaderButton",
                                                                                        {
                                                                                          attrs: {
                                                                                            promiseAwait:
                                                                                              _vm.processDeliveryInfo,
                                                                                            promiseItem: {
                                                                                              data: Object.assign(
                                                                                                {},
                                                                                                _vm.detailInShowItem
                                                                                              ),
                                                                                              type:
                                                                                                "delivery"
                                                                                            },
                                                                                            buttonText: _vm.$t(
                                                                                              "save"
                                                                                            )
                                                                                          }
                                                                                        }
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _vm._e()
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ]),
                  model: {
                    value: _vm.isShowImportOrderDetail,
                    callback: function($$v) {
                      _vm.isShowImportOrderDetail = $$v
                    },
                    expression: "isShowImportOrderDetail"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-tab-item",
              { key: "history" },
              [
                _c("PaginationController", {
                  attrs: {
                    getDataActionName: "getImportService",
                    showDataLimit: _vm.showDataLimit,
                    searchBoxLabel: _vm.$t("search"),
                    searchBoxHint: _vm.$t("importSearchBoxHint"),
                    select: _vm.closedSelectedImportStatus || null,
                    actionPredicates: _vm.historyActionPredicates,
                    isRefreshSelect: false,
                    isStartWithoutData: "",
                    haveSearchBox: "",
                    haveStartDate: "",
                    "mb-4": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "dataTable",
                      fn: function() {
                        return [
                          _c("v-data-table", {
                            staticClass: "elevation-2 myDense",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.closedBillingList,
                              "hide-actions": "",
                              "item-key": "_key",
                              "select-all": "blue",
                              "rows-per-page-items": _vm.rowPerPage,
                              "custom-sort": _vm.sortTableData
                            },
                            on: {
                              "update:items": function($event) {
                                _vm.closedBillingList = $event
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "headers",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "tr",
                                      _vm._l(props.headers, function(header) {
                                        return _c(
                                          "th",
                                          {
                                            key: header.text,
                                            style: {
                                              width: header.width,
                                              textAlign: header.align
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(header.text) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                }
                              },
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(props.item.billingNumber) +
                                            "\n                    "
                                        ),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _vm.isAdmin &&
                                                      props.item
                                                        .billingNumber !==
                                                        props.item
                                                          .masterBillingNumber
                                                        ? _c(
                                                            "v-icon",
                                                            _vm._g(
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "16px"
                                                                },
                                                                attrs: {
                                                                  color: "blue",
                                                                  small: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.copyToClipboard(
                                                                      props.item
                                                                        .masterBillingNumber
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              on
                                                            ),
                                                            [_vm._v("info")]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "copyMasterBillingNumber"
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(props.item.containerNumber))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.toDateString(
                                            props.item.lastModifiedTime
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { style: { whiteSpace: "pre-wrap" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            props.item.serviceTypes.length
                                              ? props.item.serviceTypes.reduce(
                                                  function(pre, cur) {
                                                    return (
                                                      _vm.$t(pre) +
                                                      "\n" +
                                                      _vm.$t(cur)
                                                    )
                                                  }
                                                )
                                              : ""
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.$t(props.item.lastStatus))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.isAdmin
                                      ? _c("td", [
                                          _vm._v(_vm._s(props.item.displayName))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isAdmin
                                      ? _c(
                                          "td",
                                          { style: { whiteSpace: "pre" } },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.internalNote)
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { attrs: { "text-xs-center": "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      dark: "",
                                                      color: "primary",
                                                      flat: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.showDetailPopup(
                                                          props.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                            " +
                                                        _vm._s(_vm.$t("open")) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.isAdmin
                                              ? _c(
                                                  "v-menu",
                                                  {
                                                    attrs: { "offset-y": "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            return [
                                                              _c(
                                                                "v-btn",
                                                                _vm._g(
                                                                  {
                                                                    attrs: {
                                                                      flat: "",
                                                                      dark: "",
                                                                      color:
                                                                        "primary"
                                                                    }
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "more"
                                                                        )
                                                                      ) +
                                                                      "\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list",
                                                      [
                                                        props.item
                                                          .billingNumber ===
                                                        props.item
                                                          .masterBillingNumber
                                                          ? _c(
                                                              "v-list-tile",
                                                              {
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.updateItem(
                                                                      props.item,
                                                                      "reopen"
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "reopen"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.selectedItems,
                              callback: function($$v) {
                                _vm.selectedItems = $$v
                              },
                              expression: "selectedItems"
                            }
                          })
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "beforeSearchBox",
                      fn: function() {
                        return [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "",
                                wrap: "",
                                "justify-start": "",
                                "align-baseline": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { sm6: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      label: _vm.$t("selectStatus"),
                                      items: _vm.statusList,
                                      "item-value": "status",
                                      "item-text": "text",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.closedSelectedImportStatus,
                                      callback: function($$v) {
                                        _vm.closedSelectedImportStatus = $$v
                                      },
                                      expression: "closedSelectedImportStatus"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ]),
                  model: {
                    value: _vm.closedBillingList,
                    callback: function($$v) {
                      _vm.closedBillingList = $$v
                    },
                    expression: "closedBillingList"
                  }
                })
              ],
              1
            )
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8e95960", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8e95960","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImportService.vue
// module id = null
// module chunks = 